import React from "react";
import { DEMO_COLORS } from "./demoStyles";

/**
 * Timeline lateral — mostra os eventos de negócio derivados da
 * pipeline real da IA. Aparece à direita do chat durante a demo.
 */
export default function TimelineRail({ events, running }) {
  return (
    <div
      data-testid="demo-timeline-rail"
      style={{
        width: 300,
        background: DEMO_COLORS.panel,
        borderLeft: `1px solid ${DEMO_COLORS.divider}`,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          padding: "12px 16px",
          borderBottom: `1px solid ${DEMO_COLORS.divider}`,
        }}
      >
        <div style={{ fontSize: 13, fontWeight: 600, color: DEMO_COLORS.text }}>
          🧠 O que o AgentUS está fazendo
        </div>
        <div style={{ fontSize: 10, color: DEMO_COLORS.textDim, marginTop: 3 }}>
          {running ? (
            <span style={{ color: DEMO_COLORS.accent }}>● Em execução</span>
          ) : (
            "Cada linha é uma decisão real da IA"
          )}
        </div>
      </div>
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "16px 12px",
          fontSize: 12,
        }}
      >
        {(!events || events.length === 0) && (
          <div
            data-testid="demo-timeline-empty"
            style={{
              color: DEMO_COLORS.textDim,
              textAlign: "center",
              padding: 24,
              lineHeight: 1.6,
            }}
          >
            A timeline vai preencher aqui
            <br />
            conforme a IA opera.
          </div>
        )}
        {(events || []).map((e, idx) => (
          <TimelineItem
            key={e.id || idx}
            event={e}
            isFirst={idx === 0}
            isLast={idx === events.length - 1}
          />
        ))}
      </div>
    </div>
  );
}

function TimelineItem({ event, isFirst, isLast }) {
  const detail = event.detail || {};
  const preview =
    detail.preview ||
    detail.name ||
    detail.label ||
    detail.intent ||
    (detail.chars ? `${detail.chars} caracteres` : "") ||
    (detail.appointment_id ? "confirmado" : "");
  return (
    <div
      data-testid={`timeline-item-${event.event}`}
      style={{
        display: "flex",
        gap: 10,
        alignItems: "flex-start",
        padding: "4px 0",
        position: "relative",
      }}
    >
      {/* linha vertical */}
      {!isLast && (
        <div
          style={{
            position: "absolute",
            left: 11,
            top: 22,
            bottom: -4,
            width: 1,
            background: DEMO_COLORS.divider,
          }}
        />
      )}
      <div
        style={{
          width: 22,
          height: 22,
          borderRadius: "50%",
          background: isFirst ? DEMO_COLORS.accent : DEMO_COLORS.panelAlt,
          border: `1px solid ${DEMO_COLORS.divider}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 11,
          flexShrink: 0,
          zIndex: 1,
        }}
      >
        {event.icon || "•"}
      </div>
      <div style={{ flex: 1, paddingBottom: 12 }}>
        <div style={{ fontSize: 12, color: DEMO_COLORS.text, fontWeight: 500 }}>
          {event.label}
        </div>
        {preview && (
          <div
            style={{
              fontSize: 11,
              color: DEMO_COLORS.textDim,
              marginTop: 2,
              lineHeight: 1.4,
              wordBreak: "break-word",
            }}
          >
            {String(preview).slice(0, 80)}
          </div>
        )}
      </div>
    </div>
  );
}
